import axios from 'axios';
import { clearSession, session } from '../utils/AuthSession';
var qs = require('qs');

const redirectToLogin = () => {
	clearSession()
	if (window.location.pathname !== '/login') {
		window.location.href = '/login'
	}
}

export const Api = async (params,pub=true) => {

    let response
	
	const config = {
		baseURL: (pub)?(process.env.REACT_APP_CORE):(process.env.REACT_APP_BASE_URL),
		timeout: process.env.REACT_APP_REQUEST_TIMEOUT,
	}
    // return session().token.token
	if(params.access==='auth'){
		const activeSession = session()
		if (!activeSession) {
			redirectToLogin()
			return { status: false, message: 'Session expired' }
		}
		config.headers = {'Authorization': `${activeSession.type} ${activeSession.token}`}
	}

	// Header tambahan per panggilan, mis. kunci PIN menu Sinkronisasi.
	if(params.headers){
		config.headers = Object.assign({}, config.headers, params.headers)
	}

	try {
		switch (params.method) {
			case 'get':
				response =  await axios.get(params.url+'?'+qs.stringify(params.reqBody),config)
				break;
			case 'post':
				response =  await axios.post(params.url,params.reqBody,config)
				break;
			case 'put':
				config.data = params.reqBody;
				response =  await axios.put(params.url,params.reqBody,config)
				break;
			case 'delete':
				config.data = params.reqBody;
				response =  await axios.delete(params.url, config)
				break;
			default:
				break;
		}

		return response.data

	} catch (error) {
		if(!error.response){
			return error
		}else{
			if(error.response.status === 401){
				redirectToLogin()
			}
			return error.response.data
		}
	}
}
